<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout column fill-height justify-start>
      <v-layout column fill-height justify-start>
        <v-layout fill-height ref="sessions" >
          <scroll-table
            :data="getTable"
            :options="getOptions"
            :sortable="false"
            @remove="(payload) => deleteSession(payload)"
            @select=""
          />
        </v-layout>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>

import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'

export default {

  name: 'ADMIN_SETTINGS_MODAL',

  components: {
    loadingCircle,
    scrollTable
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({
    loader: false,
    sessions: [],
    options: {
      columns: {
        text: {
          width: '40%'
        },
        timestamp: {
          width: '20%'
        },
        check: {
          width: '5%'
        },
        actions: {
          width: '20%'
        }
      },
    },

    table: {
      columns: [
        {
          title: 'user',
          value: 'userName',
          dataKey: 'userName',
          type: 'text',
          width: '50%'
        },       
        {
          title: 'ip address',
          value: 'ip',
          dataKey: 'ip',
          type: 'text',
          width: '30%'
        }, 
        {
          title: 'session start time',
          value: 'startRT',
          dataKey: 'startRT',
          type: 'timestamp',
          width: '15%'
        },
        {
          title: 'actions',
          value: '',
          dataKey: '',
          type: 'actions',
          width: '8%',
          actions: [
            {
              title: 'remove',
              tooltip: 'remove',
              icon: 'basket',
              color: 'red',
              size: 15,
              emit: 'remove'
            }
          ],
        }
      ],
      rows: []
    }
  }),

  computed: {
    getData: function () {
      return this.data
    },

    getSessions: function () {
      return this.sessions
    },

    getTable: function () {
      let t = this.$merge({}, this.table)
      return t
    },

    getOptions: function () {
      return this.options
    },
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {
    setup: async function () {
      console.log(this.$options.name, 'data', this.data)
      this.reset()
      this.loadSessions()
    },
    
    loadSessions: async function () {
      let sessions = await this.$bridge.customQuery('alarm', `auth/sessions`, {}, 'GET')
      console.log(this.$options.name, 'sessions', sessions)
      if(sessions) {
        this.sessions = sessions
        this.table.rows = sessions
      }
    },
    
    deleteSession: async function (val) {
      console.log(this.$options.name, 'deleteSession', val)
      let del = await this.$bridge.customQuery('alarm', `auth/session/${val.id}`, {}, 'DELETE')
      if(del) {
        this.loadSessions()
      }
    },

    reset: function () {}

  }

}
</script>

<style scoped>
</style>
